import { render } from "./skills.vue?vue&type=template&id=334bc8ff"
import script from "./skills.vue?vue&type=script&lang=js"
export * from "./skills.vue?vue&type=script&lang=js"

import "./skills.vue?vue&type=style&index=0&id=334bc8ff&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__